export type Sleep = (miliseconds: number) => Promise<void>;
export const sleep: Sleep = miliseconds => new Promise(resolve => setTimeout(resolve, miliseconds));
